import InterfaceAdd from './InterfaceAdd';
import InterfaceAddCirc from './InterfaceAddCirc';
import InterfaceAlert from './InterfaceAlert';
import InterfaceCheck from './InterfaceCheck';
import InterfaceCheckCirc from './InterfaceCheckCirc';
import InterfaceChevronDown from './InterfaceChevronDown';
import InterfaceChevronUp from './InterfaceChevronUp';
import InterfaceClose from './InterfaceClose';
import InterfaceInfo from './InterfaceInfo';
import InterfaceLess from './InterfaceLess';
import InterfaceLessCirc from './InterfaceLessCirc';
import InterfaceMenu from './InterfaceMenu';
import InterfaceTrash from './InterfaceTrash';

export default {
  InterfaceAdd,
  InterfaceAddCirc,
  InterfaceAlert,
  InterfaceCheck,
  InterfaceCheckCirc,
  InterfaceChevronDown,
  InterfaceChevronUp,
  InterfaceClose,
  InterfaceInfo,
  InterfaceLess,
  InterfaceLessCirc,
  InterfaceMenu,
  InterfaceTrash
};
